/* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { token } from '@atlaskit/tokens';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';

import Item, { type SwitcherItemProps } from './item';

// add !important to override the default styles
// temp workaround to fix mix usage of emotion and compiled css: https://hello.jira.atlassian.cloud/browse/NAVX-551
const itemStyles = css({
	padding: `${token('space.100', '8px')} !important`,
	borderRadius: `${token('border.radius', '4px')} !important`,
});

const iconStyles = css({
	marginRight: `${token('space.negative.050', '-4px')}`,
});

export default (props: SwitcherItemProps) => {
	const { icon, ...rest } = props;
	return <Item icon={<span css={iconStyles}>{icon}</span>} {...rest} css={itemStyles} />;
};
